import { render, staticRenderFns } from "./AlertDealsListComponent.vue?vue&type=template&id=f1eefaa8&scoped=true&"
import script from "./AlertDealsListComponent.vue?vue&type=script&lang=ts&"
export * from "./AlertDealsListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AlertDealsListComponent.vue?vue&type=style&index=0&id=f1eefaa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1eefaa8",
  null
  
)

export default component.exports